/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShipperTargetDto } from '../../models/create-shipper-target-dto';
import { ShipperTarget } from '../../models/shipper-target';

export interface CreateOneBaseMgmtShipperTargetControllerShipperTarget$Params {
  shipperId: number;
      body: CreateShipperTargetDto
}

export function createOneBaseMgmtShipperTargetControllerShipperTarget(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperTarget>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtShipperTargetControllerShipperTarget.PATH, 'post');
  if (params) {
    rb.path('shipperId', params.shipperId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipperTarget>;
    })
  );
}

createOneBaseMgmtShipperTargetControllerShipperTarget.PATH = '/api/mgmt/shipper/{shipperId}/targets';
